import { find } from 'lodash/fp';

import Themes from './Themes';


const THEME_KEY = 'chosen-theme-key';
const AUTO_DARK_MODE_KEY = 'auto-dark-mode';

export const save = async (newTheme) => {
  window.localStorage.setItem(THEME_KEY, newTheme.key);
};

export const saveAutoDarkMode = (isEnabled) => {
  window.localStorage.setItem(AUTO_DARK_MODE_KEY, JSON.stringify(isEnabled));
};

const getChosenTheme = () => {
  const chosenThemeKey = window.localStorage.getItem(THEME_KEY);
  const autoToggleDarkMode = window.localStorage.getItem(AUTO_DARK_MODE_KEY);
  const theme = find((t) => t.key === chosenThemeKey, Themes);
  return {
    theme,
    autoDarkMode: autoToggleDarkMode ? JSON.parse(autoToggleDarkMode) : undefined,
  };
};

export const applyThemeGlobals = (theme) => {
  window.document.bgColor = theme.colors.background;
};

export { useDarkMode, supportsDarkMode } from '@kingstinct/react-native-dark-mode';

async function loadThemeOnce() {
  const { theme, autoDarkMode } = getChosenTheme();
  return [theme, autoDarkMode];
}

export default loadThemeOnce;
